import { useSelect, dispatch } from '@wordpress/data';
import { _n, __ } from '@wordpress/i18n';
import { PanelRow, ToggleControl } from '@wordpress/components';

export default () => {
    const settings = useSelect((select) => {
        return select('WPTravel/Admin').getAllStore()
    }, []);
    const { enable_custom_trip_code_option, modules, options } = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings && 'undefined' !== typeof moduleSettings.show_wp_travel_utilities && 'yes' === moduleSettings.show_wp_travel_utilities.value;

    const { updateSettings } = dispatch('WPTravel/Admin');

    let custom_trip_code = 'undefined' != typeof enable_custom_trip_code_option ? enable_custom_trip_code_option : 'no';
    
    if ( ! isActive ) {
        // To hide while disabling from addons settings.
        return <></>;
    }
    return <>
        <PanelRow>
            <label>{_wp_travel.setting_strings.trip_settings.custom_trip_codes}</label>
            <div id="wp-travel-trips-settings-custom-trip-codes" className="wp-travel-field-value">
                <ToggleControl
                    checked={ custom_trip_code == 'yes' }
                    onChange={ () => {
                        updateSettings({
                            ...settings,
                            enable_custom_trip_code_option: 'yes' == custom_trip_code ? 'no': 'yes'
                        })
                    } }
                />
                <p className="description">{_wp_travel.setting_strings.trip_settings.custom_trip_codes_note}</p>
            </div>
        </PanelRow> 
    </>
}